import QuoteStep from "../../features/quote/enums/QuoteStep";
import useAppStateStore from "../store/AppStateStore";
import { scrollToTop } from "./scrollUtils";

export const handlePrevious = (prevStep) => {
  if (prevStep) {
    const STATE = useAppStateStore.getState();
    STATE.setCurrentStep(prevStep);
    scrollToTop();
  }
};

export const handleNext = (nextStep) => {
  const STATE = useAppStateStore.getState();
  let currentStep = STATE.currentStep;
  if (nextStep) {
    STATE.setCurrentStep(nextStep);
    STATE.setPreviousStep(currentStep);
    scrollToTop();
  }
};

export const goBackToLastStep = () => {
  const STATE = useAppStateStore.getState();
  if (STATE.additionalDriver === "Yes") {
    handleNext(QuoteStep.TQ_ADD_DRIVER);
  } else if (STATE.claims === "Yes") {
    handleNext(QuoteStep.TQ_CLAIM);
  } else {
    handleNext(QuoteStep.TQ6);
  }
};

export const EditQuoteDetails = () => {
  const STATE = useAppStateStore.getState();
  if (STATE.additionalDriver === "Yes") {
    handleNext(QuoteStep.TQ_ADD_DRIVER);
  } else if (STATE.claims === "Yes") {
    handleNext(QuoteStep.TQ_CLAIM);
  } else {
    handleNext(QuoteStep.TQ6);
  }
};
